import { createAsyncThunk } from '@reduxjs/toolkit';
import { sysAppService, CreateSysAppRequest, UpdateSysAppRequest } from '../../services/api/sysAppService';

export const fetchSysApps = createAsyncThunk(
  'sysApp/fetchSysApps',
  async ({ page, pageSize }: { page: number; pageSize: number }, { rejectWithValue }) => {
    try {
      return await sysAppService.getApps(page, pageSize);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch apps');
    }
  }
);

export const fetchSysApp = createAsyncThunk(
  'sysApp/fetchSysApp',
  async (id: number, { rejectWithValue }) => {
    try {
      return await sysAppService.getApp(id);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch app');
    }
  }
);

export const createSysApp = createAsyncThunk(
  'sysApp/createSysApp',
  async (request: CreateSysAppRequest, { rejectWithValue }) => {
    try {
      return await sysAppService.createApp(request);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to create app');
    }
  }
);

export const updateSysApp = createAsyncThunk(
  'sysApp/updateSysApp',
  async ({ id, request }: { id: number; request: UpdateSysAppRequest }, { rejectWithValue }) => {
    try {
      await sysAppService.updateApp(id, request);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to update app');
    }
  }
);

export const deleteSysApp = createAsyncThunk(
  'sysApp/deleteSysApp',
  async (id: number, { rejectWithValue }) => {
    try {
      await sysAppService.deleteApp(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to delete app');
    }
  }
);

export const setSysAppActive = createAsyncThunk(
  'sysApp/setSysAppActive',
  async ({ id, isActive }: { id: number; isActive: boolean }, { rejectWithValue }) => {
    try {
      await sysAppService.setActive(id, isActive);
      return { id, isActive };
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to update app status');
    }
  }
);
